import Link from "next/link";
import { useRouter } from "next/router";
import { MdKeyboardArrowRight } from "react-icons/md";

const BreadCrumb = ({ items }) => {
  const { locale } = useRouter();

  return (
    <div className="px-20 max-[570px]:w-[98%] mx-auto my-5 min-h-6">
      {items?.length ? (
        <div className="flex items-center ">
          <Link href="/" className="duration-200 hover:text-red">
            {locale === "en" ? "Home" : "الرئيسية"}
          </Link>
          <MdKeyboardArrowRight
            size="20px"
            className={`mx-2 ${locale === "en" ? "rotate-0" : "rotate-180"}`}
          />

          {items.map((item, i) => {
            const link = items
              ?.slice(0, i + 1)
              .map((item) => item?.url)
              ?.join("/");
            return (
              <div key={i} className="flex items-center justify-center">
                {items?.length - 1 > i ? (
                  <Link
                    href={`/${link}`}
                    className="duration-200 hover:text-red"
                  >
                    {item?.name}
                  </Link>
                ) : (
                  <h1 className="duration-200 text-red">{item?.name}</h1>
                )}

                {items.length - 1 > i && (
                  <MdKeyboardArrowRight
                    size="20px"
                    className={`mx-2 ${
                      locale === "en" ? "rotate-0" : "rotate-180"
                    }`}
                  />
                )}
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default BreadCrumb;
